/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Input as ChakraInput,
  InputProps as ChakraInputProps,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Icon,
  InputGroup,
  InputLeftElement,
} from '@chakra-ui/react';
import { PhoneIcon } from 'lucide-react';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import InputMask from 'react-input-mask';

interface IInputPhoneProps extends Omit<ChakraInputProps, 'size'> {
  name: string;
  label?: string;
}

//Tipagem com erro devido a versão do react-input-mask
const InputMaskAny = InputMask as any;

export const InputPhone: React.FC<IInputPhoneProps> = ({
  name,
  label,
  ...rest
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <FormControl isInvalid={!!errors[name]}>
      {label && <FormLabel htmlFor={name}>{label}</FormLabel>}
      <InputGroup>
        <InputLeftElement
          pointerEvents="none"
          top="50%"
          transform="translateY(-50%)"
        >
          <Icon as={PhoneIcon} color="gray.500" h="min-content" />
        </InputLeftElement>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <InputMaskAny mask="(99) 99999-9999" maskChar={null} {...field}>
              {(inputProps: any) => (
                <ChakraInput
                  pl={10}
                  id={name}
                  {...inputProps}
                  {...rest}
                  bg="white"
                />
              )}
            </InputMaskAny>
          )}
        />
      </InputGroup>
      <FormErrorMessage>
        {errors?.[name] && (errors[name]?.message as string)}
      </FormErrorMessage>
    </FormControl>
  );
};
